import React, { useState } from "react";
import { ReactComponent as FilterIcon } from "../../../../assets/icons/modal/filter.svg";
import { orderStatusFilterSelector } from "../../../../utils/createSelector";
import DateRangeInputs from "../../../inputs/DateRangeInputs/DateRangeInputs";
import DefaultModal from "../../DefaultModal/DefaultModal";
import ModalBottomButtons from "../../forms/buttons/ModakBottomButtons/ModalBottomButtons";
import SelectInput, {
  SelectOption,
} from "../../forms/inputs/SelectInput/SelectInput";
import ModalTitle from "../../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: (
    status: SelectOption,
    startDate: Date | null,
    endDate: Date | null
  ) => void;
  defaultStatus: SelectOption;
  defaultStartDate: Date | null;
  defaultEndDate: Date | null;
}

const OrderFilterModal: React.FC<Props> = (props) => {
  const [status, setStatus] = useState<SelectOption>(
    props.defaultStatus || {
      value: "none",
      label: "all",
    }
  );

  const [startDate, setStartDate] = useState<Date | null>(
    props.defaultStartDate
  );
  const [endDate, setEndDate] = useState<Date | null>(props.defaultEndDate);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          title="Фільтр"
          subTitle='Виберіть параметри фільтра для відображення потрібних даних. Після налаштування натисніть "Застосувати" для отримання результату.'
          onClose={props.onClose}
        >
          <FilterIcon />
        </ModalTitle>
        <div className={styles.form}>
          <SelectInput
            title="Status"
            value={status}
            values={orderStatusFilterSelector}
            onChange={(value) => setStatus(value)}
          />
          <DateRangeInputs
            start={startDate}
            onChangeStart={(value) => setStartDate(value)}
            end={endDate}
            onChangeEnd={(value) => setEndDate(value)}
          />
        </div>
        <ModalBottomButtons
          onPressApply={() => {
            props.onApply(status, startDate, endDate);
            props.onClose();
          }}
          onPressBack={props.onClose}
          backTitle="Назад"
          applyTitle="Застосувати"
        />
      </div>
    </DefaultModal>
  );
};

export default OrderFilterModal;
